/** REST + WebSocket contract for support chat (not GraphQL). */
export class SupportChatApiError extends Error {
    status;
    body;
    /** Ops error code from the JSON body (e.g. `customer_banned`), when the backend supplies one. */
    code;
    constructor(message, status, body) {
        super(message);
        this.status = status;
        this.body = body;
        this.name = 'SupportChatApiError';
        if (body &&
            typeof body === 'object' &&
            typeof body.code === 'string') {
            this.code = body.code;
        }
    }
}
/** True for the 403 the backend returns on the two customer write paths for a banned customer. */
export function isCustomerBannedError(e) {
    return e instanceof SupportChatApiError && e.status === 403 && e.code === 'customer_banned';
}
